module.exports = __webpack_public_path__ + "../resources/img/storebadge_mx.8caebf24.png";